<template lang="html">
  <div class="header">
    <div class="logo" >
      <a :href="'/'+language"><Logo/></a>
    </div>
    <router-link v-if="$route.path.indexOf('configurator') >= 0" :to="'/'+language">
      <div class="back hidden">
        <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="6.061" height="10.707" viewBox="0 0 6.061 10.707">
          <path id="Arrow" d="M2001.062,807.612l-5,5,5,5" transform="translate(-1995.355 -807.258)" fill="none" stroke="#333" stroke-width="1"/>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
          <g id="Background" fill="none" stroke-width="1">
            <rect width="48" height="40" rx="20" stroke="none"/>
            <rect x="0.5" y="0.5" width="47" height="39" rx="19.5" fill="none"/>
          </g>
        </svg>
      </div>
    </router-link>
    <div v-else-if="$route.path == '/en' || $route.path == '/de'" @click="resetGallery">
      <div class="back hidden">
        <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="6.061" height="10.707" viewBox="0 0 6.061 10.707">
          <path id="Arrow" d="M2001.062,807.612l-5,5,5,5" transform="translate(-1995.355 -807.258)" fill="none" stroke="#333" stroke-width="1"/>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
          <g id="Background" fill="none" stroke-width="1">
            <rect width="48" height="40" rx="20" stroke="none"/>
            <rect x="0.5" y="0.5" width="47" height="39" rx="19.5" fill="none"/>
          </g>
        </svg>
      </div>
    </div>
    <a v-else @click="$router.go(-1)">
      <div class="back hidden">
        <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="6.061" height="10.707" viewBox="0 0 6.061 10.707">
          <path id="Arrow" d="M2001.062,807.612l-5,5,5,5" transform="translate(-1995.355 -807.258)" fill="none" stroke="#333" stroke-width="1"/>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
          <g id="Background" fill="none" stroke-width="1">
            <rect width="48" height="40" rx="20" stroke="none"/>
            <rect x="0.5" y="0.5" width="47" height="39" rx="19.5" fill="none"/>
          </g>
        </svg>
      </div>
    </a>
  </div>
</template>

<script>
import {masterBus} from '@/main.js';
import Logo from '@/components/base/Logo.vue';
import { mapGetters } from 'vuex'

export default {
  name: 'headerComponent',
  components:{
    Logo
  },
  data(){
    return{
      isMenuOpen:false
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  methods:{
    resetGallery(){
      masterBus.$emit('resetGallery','fromHeader');
    },
    switchMenu(){
      masterBus.$emit("switchMenu");
    },
    restartApp(){
      masterBus.$emit('restartApp');
    }
  }
}
</script>

<style lang="scss" >
.header{
  position: fixed;
  z-index: 9000;
  width: 100%;
  top: 0;
  .back{
    &.hidden{
      visibility: hidden;
      opacity: 0;
    }
    &.light{
        svg{
          #Background{
            stroke:white;
          }
          path{

              &#Arrow{
                fill:none;
                stroke:white;
              }
          }
        }
    }
    opacity: 1;
    visibility: visible;
    position: absolute;
    left: 60px;
    top: 50px;
    width: 50px;
    height: 40px;
    border-radius: 60px;
    z-index: 9100;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg{
      position: absolute;
      &.arrow{
        position: inherit;
        margin: auto;
        top: none !important;
      }
    }
    // padding: .9rem 2rem;
    #Background{
      stroke:#333;
    }
    path{
        &#Arrow{
          fill:none;
          stroke:#333;
        }
    }
  }
}
.dark-mode{
  .back{
    border:solid 1px rgba(255, 255, 255, 0.52);
    svg{
      path{
          fill:white;
      }
    }
  }
}

.isMobile,.deviceRotate,.expand{
  .logo{
    width: 100px;
    top:40px;
  }
  .logo_svg{
    .st1{
      path{
        fill:#4C5356 !important;;
      }
    }
    .st2{
      path{
        fill:black !important;
      }
    }
  }
}
.deviceRotate{
  .logo{
    width: 200px;
    height: 40.7px;
    top:60px;
  }
}

.logo{
  position: absolute;
  top:60px;
  left: 0;
  right: 0;
  margin:auto;
  width: 200px;
  height: 40.7px;
  a{
    width: 100%;
    svg{
      width: 100%;
    }
  }
}
  .trigger{
    position: absolute;
    left: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    border-radius: 60px;
    z-index: 9100;
  }

  $bar-width: 20px;
  $bar-height: 1px;
  $bar-spacing: 6px;

 .menu-wrapper {
  width: $bar-width;
	height: $bar-height + $bar-spacing*2;
  position: absolute;
  top: 0;
  bottom:0;
  left:0;
  right:0;
  margin: auto;
	cursor: pointer;
}

@media only screen and (max-width: 400px)  {
  .header{
    .back{
      left:30px;
      top:30px;
    }
  }
}
</style>
